var _circle, _circle2, _path, _path2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 144,
    viewBox: "0 0 288 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 0.000297546,
    r: 45.2237,
    stroke: "#EFF4FF",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 0.000282288,
    r: 69.8553,
    stroke: "#EFF4FF",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.487 0.000259399C238.487 52.1839 196.184 94.4871 144 94.4871C91.8166 94.4871 49.5134 52.1839 49.5134 0.000259399C49.5134 -52.1834 91.8166 -94.4866 144 -94.4866C196.184 -94.4866 238.487 -52.1834 238.487 0.000259399Z",
    stroke: "#EFF4FF",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.118 1.52588e-05C263.118 65.7873 209.787 119.118 144 119.118C78.2127 119.118 24.8816 65.7873 24.8816 1.52588e-05C24.8816 -65.7873 78.2127 -119.118 144 -119.118C209.787 -119.118 263.118 -65.7873 263.118 1.52588e-05Z",
    stroke: "#EFF4FF",
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    r: 143.75,
    stroke: "#EFF4FF",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/Circles.423f906636821293deee3991408adedf.svg";
export { ForwardRef as ReactComponent };